import { TableLandingSupportContainer} from "../../containers/SupportSystem/TableLandingSupportContainer";

export function TableLandingSupportPage() {
    return (
        <TableLandingSupportContainer />
    )
}